import { motion } from 'framer-motion';
import type { HandSortMode } from '../lib/handSort.js';
import { SORT_LABELS } from '../lib/handSort.js';

interface HandSortButtonProps {
  mode: HandSortMode;
  onCycle: () => void;
}

export function HandSortButton({ mode, onCycle }: HandSortButtonProps) {
  return (
    <motion.button
      type="button"
      onClick={onCycle}
      whileTap={{ scale: 0.94 }}
      aria-label={`Сортировка: ${SORT_LABELS[mode]}`}
      className="pill-glass flex items-center gap-1.5 px-3 py-1.5 text-xs"
      style={{ color: 'var(--color-gold)' }}
    >
      <SortIcon mode={mode} />
      <span style={{ fontFamily: 'var(--font-display)', letterSpacing: '0.04em' }}>
        {SORT_LABELS[mode]}
      </span>
    </motion.button>
  );
}

function SortIcon({ mode }: { mode: HandSortMode }) {
  // Three glyphs that visually map to sort intent.
  if (mode === 'suit') {
    return (
      <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
        {/* spade */}
        <path d="M5.2 7.2 C5.2 8.4 6.2 9.4 7 9.4 C6.8 10 6.2 10.4 5.6 10.6 L4.4 10.6 L4.4 11.4 L7.6 11.4 L7.6 9.4 C7.6 9.4 8.4 9.4 9 8.4 C9.6 7.4 9 6.6 7.6 5.4 L7 5 L6.4 5.4 C5 6.6 5.2 7.2 5.2 7.2 Z" />
        {/* mini diamond */}
        <path d="M11.5 4 L13 5.5 L11.5 7 L10 5.5 Z" />
      </svg>
    );
  }
  if (mode === 'rank') {
    // numeric/list bars
    return (
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
        <line x1="3" y1="4" x2="13" y2="4" />
        <line x1="3" y1="8" x2="11" y2="8" />
        <line x1="3" y1="12" x2="9" y2="12" />
      </svg>
    );
  }
  // auto — magic-wand-ish sparkles
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 13 L11 5" />
      <path d="M9 3 L11 5 L13 3" />
      <path d="M2 6 L4 6 M3 5 L3 7" />
      <path d="M12 11 L14 11 M13 10 L13 12" />
    </svg>
  );
}
